// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

function FullScreenConatiner({ children = <></>, subHeight = 117, style = {} }) {
    return (
        <div
            className="mx-4 my-3 background-color-white  box-shadow--full-container"
            style={{
                minHeight: `calc(100vh - ${subHeight}px)`,
                borderRadius: "5px",
                ...style,
            }}
        >
            {children}
        </div>
    );
}

FullScreenConatiner.propTypes = {
    children: PropTypes.object,
    style: PropTypes.object,
    subHeight: PropTypes.number,
};

export default FullScreenConatiner;
